import type { Network } from '../../schema/row-types.ts';
import type {
  RowOrderBy,
  RowQuery,
  SqliteQueryOptions,
} from '../../types/query.ts';
import { networks } from '../../schema/tables/gtfs-schedule/networks.ts';
import { findRows } from '../sqlite-query.ts';

/**
 * Returns an array of all networks that match the query parameters.
 * @param query Column values to match, as single values or arrays
 * @param fields Columns to select, or every column when empty
 * @param orderBy Column and direction pairs to sort by
 * @param options Query options, including the database to read from
 * @returns Matching rows, containing only `fields` when it is not empty
 */
export function getNetworks<Fields extends keyof Network>(
  query: RowQuery<Network> = {},
  fields: readonly Fields[] = [],
  orderBy: RowOrderBy<Network> = [],
  options: SqliteQueryOptions = {},
) {
  return findRows<Network, Fields>(networks, query, fields, orderBy, options);
}
